import "./Terms.css";

const TERMS_UPDATED_AT = "19 أغسطس 2026";

export function webinarReturnPath(search = window.location.search) {
  const returnTo = new URLSearchParams(search).get("returnTo") || "";

  if (
    !returnTo.startsWith("/") ||
    returnTo.startsWith("//") ||
    returnTo.startsWith("/terms")
  ) {
    return "/";
  }

  return returnTo;
}

function Terms() {
  const returnPath = webinarReturnPath();

  return (
    <main className="terms-page" dir="rtl">
      <header className="terms-header">
        <p className="terms-eyebrow">حسين نديم | مدرب تخطيط الحياة</p>
        <h1>شروط استخدام وحضور الويبينارات</h1>
        <p>آخر تحديث: {TERMS_UPDATED_AT}</p>
      </header>

      <div className="terms-content">
        <section>
          <h2>1. قبول الشروط</h2>
          <p>
            عند تحديد مربع الموافقة وإتمام التسجيل، فإنك تقر بأنك قرأت هذه
            الشروط وفهمتها وتوافق على الالتزام بها.
          </p>
        </section>

        <section>
          <h2>2. الأهلية للتسجيل</h2>
          <p>
            التسجيل متاح لمن يبلغ عمره 18 سنة أو أكثر. ويجب تقديم اسم وبريد
            إلكتروني صحيحين حتى نتمكن من إدارة التسجيل وإرسال معلومات اللقاء.
          </p>
        </section>

        <section>
          <h2>3. رسائل اللقاء الضرورية</h2>
          <p>
            يستخدم الاسم والبريد الإلكتروني لإرسال تأكيد التسجيل، ورابط Zoom،
            وتذكيرات اللقاء، وأي إشعار ضروري يتعلق بتغيير الموعد أو إلغاء
            اللقاء. لا تتضمن هذه الموافقة اشتراكاً اختيارياً في الرسائل
            التسويقية.
          </p>
        </section>

        <section>
          <h2>4. رابط Zoom والحضور</h2>
          <p>
            يرسل رابط الدخول إلى البريد المستخدم في التسجيل. يتحمل المشارك
            مسؤولية استخدام الرابط بصورة مشروعة، ويحق للمنظم إيقاف الوصول عند
            إساءة الاستخدام أو مخالفة هذه الشروط.
          </p>
        </section>

        <section>
          <h2>5. قواعد السلوك</h2>
          <p>
            يلتزم المشارك باحترام المدرب وبقية الحاضرين، وعدم تعطيل اللقاء أو
            انتحال شخصية الغير أو نشر محتوى مسيء أو غير قانوني. يجوز استبعاد أي
            مشارك يخالف هذه القواعد.
          </p>
        </section>

        <section>
          <h2>6. التسجيل وإعادة النشر</h2>
          <p>
            لا يجوز تسجيل اللقاء أو نسخه أو إعادة نشره أو توزيعه دون إذن كتابي
            مسبق من المنظم. وإذا تقرر تسجيل أي لقاء، فسيتم إبلاغ المشاركين بذلك
            مسبقاً.
          </p>
        </section>

        <section>
          <h2>7. حقوق الملكية الفكرية</h2>
          <p>
            جميع المواد التدريبية والعروض والتمارين والنصوص والصور المقدمة في
            اللقاء مخصصة للاستخدام الشخصي فقط، وتبقى حقوقها محفوظة لأصحابها.
          </p>
        </section>

        <section>
          <h2>8. طبيعة المحتوى</h2>
          <p>
            يقدم اللقاء محتوى تعليمياً وإرشادياً في مجال تخطيط الحياة، ولا يعد
            بديلاً عن الاستشارة الطبية أو النفسية أو القانونية أو المالية. لا
            يضمن المنظم نتيجة شخصية محددة من حضور اللقاء.
          </p>
        </section>

        <section>
          <h2>9. التغييرات والإلغاء</h2>
          <p>
            قد يضطر المنظم إلى تعديل الموعد أو تأجيل اللقاء أو إلغائه. في هذه
            الحالة، سيتم إخطار المسجلين باستخدام البريد الإلكتروني المسجل.
          </p>
        </section>

        <section>
          <h2>10. المتطلبات التقنية والخدمات الخارجية</h2>
          <p>
            يتحمل المشارك مسؤولية توفر اتصال الإنترنت والجهاز وتطبيق Zoom
            المناسب. تستخدم خدمات خارجية، ومنها Zoom وBrevo، لتقديم اللقاء
            وإرسال رسائله، وقد تخضع هذه الخدمات لشروطها وسياسات الخصوصية الخاصة
            بها.
          </p>
        </section>

        <section>
          <h2>11. الخصوصية</h2>
          <p>
            تجمع البيانات اللازمة لإدارة التسجيل واللقاء فقط، ويتم التعامل
            معها وفق القوانين السارية. يمكن للمشارك طلب الاستفسار عن بياناته أو
            تحديثها أو حذفها، مع مراعاة أي التزامات قانونية واجبة.
          </p>
        </section>

        <section>
          <h2>12. المسؤولية</h2>
          <p>
            يبذل المنظم جهداً معقولاً لتقديم اللقاء في موعده وبجودة مناسبة، لكنه
            لا يتحمل مسؤولية الأعطال أو الانقطاعات الناتجة عن Zoom أو الإنترنت
            أو أجهزة المشاركين أو الظروف الخارجة عن إرادته.
          </p>
        </section>

        <section>
          <h2>13. تعديل الشروط</h2>
          <p>
            يجوز تحديث هذه الشروط عند الحاجة. ويسري على كل تسجيل إصدار الشروط
            المعروض وقت إتمام ذلك التسجيل.
          </p>
        </section>

        <section>
          <h2>14. التواصل</h2>
          <p>
            لأي استفسار متعلق بهذه الشروط أو بالتسجيل، يمكنك التواصل عبر البريد
            الإلكتروني: <a href="mailto:info@huseinnadeem.com">info@huseinnadeem.com</a>.
          </p>
        </section>
      </div>

      <a className="terms-home-link" href={returnPath}>
        العودة إلى صفحة الويبينار
      </a>
    </main>
  );
}

export default Terms;
